export default __webpack_public_path__ + "static/media/use4.e7fa539b.png";